import axios from 'axios';
import store from '@/store';
import {getRequestClientInfo} from '@threegene/common-js/xdm/request-config/get-request-header-config';

const api = axios.create({
  timeout: 10000,
  baseURL: process.env.NODE_ENV === 'production' ? location.origin + '' : ''
});

// 统一设置 post 请求头
api.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 检查状态码
function checkStatus(res) {
  // 结束
  if (res.status === 200 || res.status === 304) {
    return res.data;
  }
  return {
    code: 0,
    msg: res.data.msg || res.statusText,
    data: res.statusText
  };
}
// 检查CODE值
function checkCode(res) {
  if (res.code === 0) {
    throw new Error(res.msg);
  }

  return res;
}

// 请求拦截
api.interceptors.request.use(
  async config => {
    // 设置默认请求token
    config.headers.token = store.getters['global/token'];
    config.headers.clientInfo = JSON.stringify(await getRequestClientInfo());
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截
api.interceptors.response.use(
  res => {
    return res;
  },
  error => {
    // 所有服务器错误跳转到错误页面
    return Promise.reject(error);
  }
);

export const post = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    api({
      method: 'post',
      url,
      data: data || {}
    })
      .then(res => {
        res = checkStatus(res);
        resolve(res);
      })
      .catch(error => {
        error = checkCode(error);
        reject(error);
      });
  });
};



// WEBPACK FOOTER //
// ./src/js/fetch/api.js